import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';

async function ListaCadastroPdf(cadastros) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // ✅ Busca dados da empresa
    const empresa = await getEmpresa();

    const reportTitle = {
        text: 'Relatório de Cadastros de Clientes',
        color: '#333333',
        fontSize: 18,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 30]
    };

    const tableHeader = [
        { text: 'Código', style: 'tableHeader' },
        { text: 'Nome', style: 'tableHeader' },
        { text: 'CPF/CNPJ', style: 'tableHeader' }
    ];

    const tableBody = cadastros.map((cadastro, index) => {
        const fillColor = index % 2 === 0 ? '#f9f9f9' : '#ffffff';
        return [
            { text: cadastro.COD_CADASTRO, style: 'tableCell', fillColor },
            { text: cadastro.RAZAO, style: 'tableCell', fillColor },
            { text: cadastro.CNPJ, style: 'tableCell', fillColor }
        ];
    });

    const details = {
        table: {
            headerRows: 1,
            widths: [60, '*', '*'],
            body: [
                tableHeader,
                ...tableBody
            ]
        },
        layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? '#e0e0e0' : null),
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#cccccc',
            vLineColor: () => '#cccccc',
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 6,
            paddingBottom: () => 6
        }
    };

    const docDefinition = {
        pageSize: 'A4',

        // 🔹 margem maior por causa do header global
        pageMargins: [20, 90, 20, 40],

        // ✅ Header padrão (empresa + data + hora)
        header: headerEmpresa(empresa),

        content: [
            reportTitle,
            details
        ],

        footer: (currentPage, pageCount) => ({
            columns: [
                {
                    text: '',
                    alignment: 'left',
                    margin: [20, 10, 0, 0],
                    fontSize: 9,
                    color: '#888888'
                },
                {
                    text: `${currentPage} de ${pageCount}`,
                    alignment: 'right',
                    margin: [0, 10, 20, 0],
                    fontSize: 9,
                    color: '#888888'
                }
            ]
        }),

        styles: {
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: '#ffffff',
                fillColor: '#1976d2',
                alignment: 'center',
                margin: [0, 5, 0, 5]
            },
            tableCell: {
                fontSize: 9,
                color: '#333333',
                margin: [0, 4, 0, 4]
            }
        }
    };

    pdfMake.createPdf(docDefinition).open();
}

export default ListaCadastroPdf;